import { Grid, LinearProgress, pxToRem, Typography } from "@platform/style";
import { WorkItem } from "../../models/WorkItem";
import { ActivityRecordPage } from "../../models/ActivityRecordPage";
import { useGetWithToken } from "@platform/core";
import { WORK_ITEMS_BFF_API_BASE } from "../../platform-workitems";
import { RenderDetails } from "../myWorkItems/RenderDetails";
import { RenderHistory } from "./RenderHistory";
import React from "react";

interface ViewInactiveWIDetailsProps {
  workItem: WorkItem;
  loanNumber: string;
}

export const ViewInactiveWIDetails = ({ workItem, loanNumber }: ViewInactiveWIDetailsProps) => {
  const [data, isLoading, isErrored, refetch, errorStack, correlationId] =
    useGetWithToken<ActivityRecordPage | null>(
      `${WORK_ITEMS_BFF_API_BASE}/${workItem.WorkItemIdentifier}/activity`,
      null
    );

  return (
    <>
      {isLoading ? <LinearProgress sx={{ mt: 1.5 }} /> : null}
      <Grid container paddingTop={pxToRem(10)}>
        <Typography component="span" variant={"h5"} id={"wiTitle"}>
          Work Item: {workItem.Title}
        </Typography>
      </Grid>
      <RenderDetails workItem={workItem} loanNumber={loanNumber} isInactiveWITab={true} />
      <Grid container paddingTop={pxToRem(15)}>
        <Typography component="span" variant={"h5"} id={"wiHistory"}>
          Work Item History
        </Typography>
      </Grid>
      {data || isErrored ? (
        <RenderHistory
          data={data}
          refetch={refetch}
          correlationId={correlationId}
          isErrored={isErrored}
          errorStack={errorStack}
        />
      ) : null}
    </>
  );
};
